import HTTP from "@/_helpers/http";
import { TRADABLEBONUS__API } from "@/_helpers/urls";
import { TRADABLEBONUS__MUTATIONS } from "../mutation-types";
import { TRADABLEBONUS__ACTIONS } from "../action-types";

const state = {
  tradablebonus: [],
  tradableBonusAccountInfo: {},
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  },
  isLoading: false,
};

const getters = {};

const mutations = {

  [TRADABLEBONUS__MUTATIONS.TRADABLEBONUSHISTORY](state, data) {

    // Update trades
    state.trades = data?.data?.trades || [];

    // Update pagination
    state.pagination = data?.data?.pagination || {
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 1
    };

    state.lastUpdate = new Date().toISOString();
  },
  [TRADABLEBONUS__MUTATIONS.TRADABLEBONUSACCOUNTINFO](state, payload) {
    state.tradableBonusAccountInfo = payload; // whole object from backend
  },

  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
};

const actions = {
    async [TRADABLEBONUS__ACTIONS.CREATETRADABLEBONUSACCOUNT]({ dispatch }, data) {
        try {
        const response = await HTTP().post(`${TRADABLEBONUS__API.CREATETRADABLEBONUSACCOUNT}`, data);
        return response.data;
        } catch (error) {
        throw error.response?.data || { message: "Something went wrong." };
        }
    },
    async [TRADABLEBONUS__ACTIONS.TRADABLEBONUSACCOUNTINFO]({ commit }) {
      try {
        const { data } = await HTTP().get(TRADABLEBONUS__API.TRADABLEBONUSACCOUNTINFO);
        commit(TRADABLEBONUS__MUTATIONS.TRADABLEBONUSACCOUNTINFO, data);
      } catch (error) {
        console.error(error);
      }
    }

};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions
};
